const date = new Date();
const offset = date.getTimezoneOffset() / 60;
const sign = offset < 0 ? "+" : "-";
const hours = Math.abs(Math.floor(offset));
const minutes = Math.abs((offset * 60) % 60);

export const timeZone = `(GMT ${sign}${hours}:${minutes.toString().padStart(2, "0")})`;
